import { apiPost } from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

export default {
  async getMenteeTasks(context, menteeId) {
    const formData = new FormData();
    formData.set('userid', menteeId);

    return apiPost('task_list', formData, 1)
      .catch((err) => {
        console.warn('Error in getting sub goals check. \n', err);
      })
      .then((res) => {
        if (!res) return [];
        if (toBoolean(res.data.error)) {
          console.warn('Error in getting sub goals check. \n', res.data.message);
          return [];
        }

        return res.data.goals_check || [];
      });
  },
};
